/*
 * @Author: 谭聪 156638174@qq.com
 * @Date: 2023-08-19 12:29:40
 * @LastEditors: 钟超 zhong-chao@cscec.com
 * @LastEditTime: 2024-03-28 15:44:50
 * @FilePath: /mall-fe/src/views/h5/Home/components/NavBar.tsx
 * @Description: 用于渲染导航栏内容
 *
 */

import { useContext } from 'react';
import { SiteContext } from 'libs/contexts';
import { generateUniqueKey } from 'libs/utils';
import ImageRenderer, { ResourcesFrom } from './ImageRenderer';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRouter } from 'next/router';
import { appLinkRecirect } from '@/libs/helper';

interface NavProps {
  icon: string;
  name: string;
  url: string;
}
const length = 5;

// const isMiniProgramLink = (url) => ParseUrl(url)?.query?.miniProgramPath;

/**
 * @description: NavBar组件用于渲染导航栏内容
 */
function NavBar() {
  // 使用 useContext 获取上下文信息
  const site = useContext(SiteContext);
  const router = useRouter();
  // 从上下文中获取导航列表并生成唯一键值
  const navList = generateUniqueKey<NavProps>(site?.global?.h5MobileNavList || []);
  // 微信环境 or 企业微信（三局通）放开个人商城链接
  const castNavList = navList;

  const goToLinkPage = (url) => {
    appLinkRecirect(url, router);
  };
  return (
    <div className="nav-main">
      {/* 使用 Swiper 组件来创建导航轮播 */}
      <Swiper
        slidesPerView={length}
        modules={[Pagination]}
        pagination={{
          type: 'progressbar',
        }}
      >
        {/* 循环渲染每个导航项 */}
        {castNavList.map((nav) => (
          <SwiperSlide key={nav.__key}>
            <span onClick={() => goToLinkPage(nav.url)}>
              <a className="nav-content">
                <div className="nav-content-icon-shell">
                  <ImageRenderer path={nav.icon} resourcesFrom={ResourcesFrom.publicCloud} />
                </div>
                <span className="nav-content-name">{nav.name}</span>
              </a>
            </span>
          </SwiperSlide>
        ))}
      </Swiper>
      <style jsx global>
        {`
          .nav-main :global(.swiper) {
            padding-bottom: 13px;
          }
          .nav-main :global(.nav-content) {
            margin: auto;
            text-align: center;
          }
          .nav-main :global(.nav-content-icon-shell) {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            margin-bottom: 8px;
            margin: auto;
          }
          .nav-main :global(.nav-content-name) {
            display: inline-block;
            width: 100%;
            font-size: 12px;
            line-height: 16px;
            color: #333333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .nav-main :global(.swiper-pagination) {
            width: 10%;
            left: 50%;
            transform: translateX(-50%);
            top: auto;
            bottom: 2px;
            border-radius: 9px;
            background: rgba(0, 128, 255, 0.1);
            overflow: hidden;
          }
          .nav-main :global(.swiper-pagination-progressbar-fill) {
            background: #0080ff;
          }
          .nav-main {
            margin-bottom: 12px;
          }
        `}
      </style>
    </div>
  );
}

export default NavBar;
